import React from 'react';
import '../DownloadableGISData/DownloadableGISData.css';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';

class DownloadGISData extends React.Component {
    // Then we add our constructor which receives our props
    constructor(props) {
        super(props);
        this.state = {
            downloadDatas: [],
            orderIdRandom: this.props.match.params.id,
        }
    }

    componentDidMount() {
        fetch('api/Order/GetDownloadGISDataOrder?orderIdRandom=' + this.state.orderIdRandom)
            .then(response => response.json())
            .then(data => {
                //console.log({ data: data.dataReturn  });
                this.setState({ downloadDatas: data.dataReturn });
            });
    }

    downloadFile = (stateName, fileType) => {
        //console.log(stateName);
        //console.log(fileType);
        var url = "/indahgeoportal/api/GetData/GetDownloadFile?state=" + stateName + "&fileType=" + fileType;

        window.location = url;
        //fetch('api/GetData/GetDownloadFile?state=' + stateName + '&fileType=' + fileType)
            //.then(window.open())
            //.then(data => {
            //    console.log({ data: data.dataReturn });
            //    this.setState({ downloadDatas: data.dataReturn });
            //});
    };

    render() {
        if (this.state.downloadDatas === "UnavailableProduct") {
            return <Redirect push to="/UnavailableProduct" />;
        }

        if (this.state.downloadDatas === "ExpiredSubscription") {
            return <Redirect push to="/ExpiredSubscription" />;
        }

        return (
            <div className="background-color p-3">
                <div className="container-downloadable">
                    <ul className="responsive-table">
                        <li className="table-header">
                            <div className="col col-1">No.</div>
                            <div className="col col-3">State Name</div>
                            <div className="col col-3">Shape File</div>
                            <div className="col col-3 text-center">KML File</div>
                        </li>
                        {this.state.downloadDatas.length > 0 && this.state.downloadDatas.map((stateData, i) => (
                            <li className="table-row" key={i}>
                                <div className="col col-1" data-label="">{i + 1}</div>
                                <div className="col col-3" data-label="">{stateData.name}</div>
                                <div className="col col-3" data-label=""><button type="button" onClick={() => this.downloadFile(stateData.name, "shapeFile")} class="btn btn-link">Shape File</button></div>
                                <div className="col col-3" data-label=""><button type="button" onClick={() => this.downloadFile(stateData.name, "kml")} class="btn btn-link">kml File</button></div>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="col-sm-12 pt-3 text-center">
                    <Link className="" to="/">Go to Home </Link>
                </div> 
            </div>
        )
    }
}

export default DownloadGISData;


// WEBPACK FOOTER //
// ./src/components/PurchaseProduct/DownloadableGISData.js